module.exports = __webpack_public_path__ + "static/media/icon_checkmark.c990e4b2.svg";